import { Checkbox, TextField } from "@fluentui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@fluentui/react";

const EditSubModality = (props) => {
  console.log("Props in EditSubModality ----->", props);
  const [t] = useTranslation();

  return (
    <>
      {
        <div
          style={{
            padding: "18px",
            height: "270px",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            justifyContent: "space-around",
          }}
        >
          <div>
            <TextField
              className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
              name="code"
              value={props.editServiceCode}
              label={t("sub-modality.service-code")}
              required
              disabled
            />
          </div>
          <div>
            <TextField
              className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
              name="code"
              placeholder={t("sub-modality.enter-name")}
              onChange={(value, data) => {
                console.log(data);
                props.setEditServiceName(data);
                props.setEditServiceNameErrorMsg("");
              }}
              value={props.editServiceName}
              errorMessage={props.editServiceNameErrorMsg}
              label={t("sub-modality.service-name")}
              required
            />
          </div>
          <div>
            <TextField
              className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
              name="code"
              placeholder={t("sub-modality.enter-expiration-time")}
              onChange={(value, data) => {
                console.log(data);
                props.setEditExpirationTime(data);
                props.setEditExpirationTimeErrorMsg("");
              }}
              value={props.editExpirationTime}
              errorMessage={props.editExpirationTimeErrorMsg}
              label={t("sub-modality.expiration-time-mins")}
            />
          </div>
        </div>
      }
    </>
  );
};

export default EditSubModality;
